/* tslint:disable no-var-requires */
import { getCookie, deleteCookie } from '~/utils';
import { ApolloClient } from 'apollo-client';
import createUserReferralMutation from '~/mutations/createUserReferral.gql';

function setReferralCookies(name: string, value: string, expiration?: Date) {
  const domains = process.env.referralDomains?.split(',') ?? [];
  const cookieNamePrefix = process.env.referralCookiePrefix;

  domains.forEach((domain) => {
    if (window.origin.includes(domain)) {
      document.cookie = `${cookieNamePrefix}${name}=${value}; domain=${domain}; path=/;${
        expiration ? ` expires=${expiration}` : ''
      }`;
    }
  });
}

export async function captureReferrals(queryParams: any) {
  const { cjevent, referralCode, source, offerid, pubCid } = queryParams || {};

  // Internal Referrals
  if (referralCode && source === 'gala') {
    setReferralCookies('galaReferralCode', referralCode);
    if (offerid) {
      setReferralCookies('galaOfferId', offerid);
    }
  }

  // COMMISSION_JUNCTION
  if (cjevent && getCookie('cjEvent') !== cjevent) {
    // expiration must be 45 days from initial click
    const now = new Date();
    const expiration = now.setUTCDate(now.getUTCDate() + 45);

    setReferralCookies('cjEvent', cjevent, new Date(expiration));
    setReferralCookies('cjAffiliateId', pubCid, new Date(expiration));
  }

  setReferredBy(queryParams);
}

export function storedExternalAffiliateInfo() {
  if (storedCJInfo()) {
    return storedCJInfo();
  }
}

function storedCJInfo() {
  const cjEvent = getCookie('cjEvent');
  const cjAffiliateId = getCookie('cjAffiliateId');
  if (cjEvent) {
    return {
      galaPlatform: 'film',
      affiliateService: 'commissionJunction',
      affiliateId: cjAffiliateId,
      xTransactionId: cjEvent,
    };
  }
}

function setReferredBy(queryParams: any) {
  let finalReferredBy = '';
  if (process.browser) {
    const r = localStorage.getItem('r') as string;
    const referredBy = localStorage.getItem('referredBy') as string;
    const referredByParam = (queryParams.r ?? queryParams.referralCode) as
      | string
      | null;
    finalReferredBy = (referredByParam || r || referredBy || '').replace(
      /[^a-zA-Z0-9]/g,
      '',
    );
    if (finalReferredBy) {
      localStorage.setItem('referredBy', finalReferredBy);
    }
  }
}

export function removeStoredReferralInfo() {
  const domains = process.env.referralDomains?.split(',') ?? [];
  const cookieNamePrefix = process.env.referralCookiePrefix;

  domains.forEach((domain) => {
    ['galaReferralCode', 'galaOfferId', 'cjEvent', 'cjAffiliateId'].forEach(
      (name) => {
        deleteCookie(`${cookieNamePrefix}${name}`, '', domain);
      },
    );
  });

  return;
}

export async function createReferral(apollo: ApolloClient<any>) {
  const created = sessionStorage.getItem('refCreated');

  if (!created) {
    const affiliate = storedExternalAffiliateInfo();

    if (affiliate) {
      const result = await apollo.mutate({
        mutation: createUserReferralMutation,
        variables: { affiliate },
      });

      sessionStorage.setItem('refCreated', 'true');

      return result;
    }
  }
}
